export const API_URLS = {
  // Login APIs
  CONTROLPANEL_ADMIN_LOGIN_APIURL: 'User/control-panel-admin-login',
  STUDENT_LOGIN_APIURL: 'User/student-login',
  TEACHER_LOGIN_APIURL: 'Teacher/teacher-login',
  EMPLOYEE_LOGIN_APIURL: 'User/employee-login',
  PARENT_LOGIN_APIURL: 'User/parent-login',
  AUTH_LOGIN_APIURL: 'Authorization/LoginPost',
  CONTROLPANEL_FORGOT_PASSWORD_APIURL: 'User/controlPanel-admin-forgot-password',
  CONTROLPANEL_VERIFY_OTP_APIURL: 'User/controlPanel-admin-verify-otp',
  REFRESH_COMMON_TOKEN_API: 'User/control-panel-refresh-token-roleName',

  // Registration
  SIGNUP_APIURL: 'Authorization/Registration',

  // Forgot Password APIs
  EMPLOYEE_FORGOT_PASSWORD_APIURL: 'User/employee-forgot-password',
  STUDENT_FORGOT_PASSWORD_APIURL: 'User/student-forgot-password',
  PARENT_FORGOT_PASSWORD_APIURL: 'User/parent-forgot-password',

  // OTP Verify APIs
  EMPLOYEE_VERIFY_OTP_APIURL: 'User/employee-verify-otp',
  STUDENT_VERIFY_OTP_APIURL: 'User/student-verify-otp',
  PARENT_VERIFY_OTP_APIURL: 'User/parent-verify-otp',

  //Other APIs
  GET_USER_PROFILE_APIURL: 'auth/me',
  ADD_STUDENT_APIURL: 'api/AddStudent',
  ADMIN_AREA_APIURL: 'Authrization/admin-area',
  REFRESH_TOKEN_API: 'User/refresh-token',


  // Logout APIs
  ADMIN_LOGOUT_APIURL: 'User/admin-logout',
  STUDENT_LOGOUT_APIURL: 'User/student-logout',
  EMPLOYEE_LOGOUT_APIURL: 'User/employee-logout',
  PARENT_LOGOUT_APIURL: 'User/parent-logout',

  //Stream Section & Sub Stream Section
  ADD_STREAM_MASTERTABLE: 'ClassSection/addStream/MasterTable',
  ADD_SUB_STREAM_MASTERTABLE: 'ClassSection/addSubStream/MasterTable',
  GET_ALL_STREAM_MASTERTABLE: 'ClassSection/getAllStream/MasterTable',
  GET_ALL_SUB_STREAM_MASTERTABLE: 'ClassSection/getAllSubStreams/MasterTable',
  GET_ALL_CLASS_MASTERTABLE: 'ClassSection/getAllClasses/MasterTable',
  GET_ALL_CLASS_SECTION_MASTERTABLE: 'ClassSection/getAllSections/MasterTable',
  UPDATE_STREAM_MASTERTABLE: 'ClassSection/UpdateStream/MasterTable',
  DELETE_SUBSTREAM_MASTERTABLE: 'ClassSection/DeleteSubStreamMasterTable',
  UPDATE_SUB_STREAM_MASTERTABLE: 'ClassSection/updateSubstream/MasterTable',
  DELETE_SECTION_MASTERTABLE: 'ClassSection/DeleteSectionMasterTable',
  GET_ALL_SCHOOL_MAPPED_CLASSES: 'ClassSection/SchoolClasses/Get',
  DELETE_SUBJECT_MASTERTABLE: 'ClassSection/DeleteSubjectMasterTable',

  //Subject Section &  Subject Section
  GET_ALL_SUBJECT_MASTERTABLE: 'ClassSection/getAllSubjects/MasterTable',
  ADD_SUBJECT_MASTERTABLE: 'ClassSection/addSubject/MasterTable',
  UPDATE_SUBJECT_MASTERTABLE: 'ClassSection/updateSubject/MasterTable',
  UPDATE_CLASS_MASTERTABLE: 'ClassSection/updateClass/MasterTable',
  ADD_CLASS_MASTERTABLE: 'ClassSection/addClass/MasterTable',
  UPDATE_SECTION_MASTERTABLE: 'ClassSection/updateSection/MasterTable',
  DELETE_Class_MASTERTABLE: 'ClassSection/DeleteClassMasterTable',
  DELETE_STREAM_MASTERTABLE: 'ClassSection/DeleteStreamMasterTable',
  ADD_SECTION_MASTERTABLE: 'ClassSection/addSection/MasterTable',

  //ClassScetion APIs

  // CREATE_CLASS_MAPPING_APIURL: "ClassSection/UpdateClasssStreamSubStreamSectionMapping",
  CREATE_CLASS_MAPPING_APIURL: 'ClassSection/UpdateClassSectionStreamSubStreamMapping',
  GETALL_CLASS_MAPPING_APIURL: 'ClassSection/GetAllClassesWithDetails',
  // GETALL_CLASS_STREAM_SSTREAM_SEC_MAPPING_APIURL: 'ClassSection/GetAllClassesWithSecStrSubs',
  GET_CLASS_SECTION_CHECKBOX_APIURL: 'ClassSection/GetAllClassesWithSectionsMapping',
  GETALL_FREQUENCY: 'FeeManagement/FeeFrequencyMap/GetAll',
  //PeriodSection APIs

  CREATE_PERIOD_APIURL: 'ClassSection/addPeriod',
  GETALL_PERIOD_APIURL: 'ClassSection/GetAllPeriod',
  UPDATEPERIOD_APIURL: 'ClassSection/UpdatePeriod',
  DELETE_PERIOD_TABLE: 'ClassSection/DeletePeriod',

  //get All ClassPeriod TeacherscheduleList APIs

  // CREATE_CLASS_MAPPING_APIURL: "ClassSection/UpdateClasssStreamSubStreamSectionMapping",
  ADD_OR_UPDATE_ASSIGN_CLASS_PERIOD_TO_TEACHER:
    'ClassSection/UpdateOrInsertAssignClasssPeriodToTeacher',
  DELETE_ASSIGN_CLASS_PERIOD_TO_TEACHER: 'ClassSection/DeleteAssignClasssPeriodToTeacher',
  GET_ALL_ASSIGN_CLASS_PERIOD_TO_TEACHER: 'ClassSection/GetAllAssignClasssPeriodToTeacher',
  GET_BY_ID_ASSIGN_CLASS_PERIOD_TO_TEACHER: 'ClassSection/GetByIDAssignClasssPeriodToTeacher',
  //Attendence Mark APIs

  ADD_STUDENTATTENDENCEMARK_APIURL: 'Reports/addStudentAttendenceMark',
  UPDATE_STUDENTATTENDENCEMARK_APIURL: 'Reports/UpdateStudentAttendenceMark',
  GETALL_STUDENTATTENDENCEMARK_APIURL: 'Reports/GetAllStudentAttendenceMarkList',


  GET_ALL_CLASS_SUBJECT_MAPPING_APIURL: 'ClassSection/GetsubjectMappedlist',
  GET_ALL_CLASS_TEACHER_SUBJECT_MAPPING_APIURL: 'Reports/GetClassTeacherSubjectMapping',
  GET_ALL_SUBJECTS_TEACHER_APIURL: 'EmployeeManage/subject-based-teachers',


  GET_ALL_TEACHER_APIURL: "EmployeeManage/teacher",
  GET_TEACHER_ASSIGNED_CLASS_SECTION_LIST_APIURL: "EmployeeManage/getAll/TeacherAssignedClassSectionList",
  ADD_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL: "EmployeeManage/TeacherAssigned/classSection/insertAndUpdate",
  UPDATE_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL: "EmployeeManage/TeacherAssigned/classSection/insertAndUpdate",
  DELETE_TEACHER_ASSIGNED_CLASS_SECTION_APIURL: `EmployeeManage/delete/TeachersAssignedClassSection`,

  ADMIN_GET_ALL_ROLES: 'AdminDashboard/GetAllRoles',
  COMMUNICATION_MESSAGE_ALL_SENT: 'AdminDashboard/communication-messages/all-sent',
  ADMIN_COMMUNICATION_MESSAGE: 'AdminDashboard/Insert/communication-messages',

  //FeeMaster Section APIs

  ADD_FEETYPE_APIURL: 'FeeManagement/fee-type/add',
  GETALL_FEETYPE_APIURL: 'FeeManagement/fee-type/get-all',
  UPDATE_FEETYPE_APIURL: 'FeeManagement/fee-type/update',
  DELETE_FEETYPE_APIURL: 'FeeManagement/fee-type/delete',

  //FeeFrequency Section APIs

  ADD_FEEFREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/add',
  GETALL_FEEFREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/get-all',
  UPDATE_FEEFREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/update',
  DELETE_FEEFREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/delete',
  GET_ALL_FEE_TYPE_APIURL: 'FeeManagement/fee-type/get-all',
  GET_ALL_FEE_FREQUENCY_APIURL: 'FeeManagement/Fee-Frequency/get-all',

  GET_ALL_FEE_STRUCTURE_TO_CLASS_APIURL: 'FeeManagement/FeeStructure/Get',
  ADD_FEE_STRUCTURE_TO_CLASS_APIURL: 'FeeManagement/FeeStructure/Add',
  UPDATE_FEE_STRUCTURE_TO_CLASS_APIURL: 'FeeManagement/FeeStructure/Update',
  DELETE_FEE_STRUCTURE_TO_CLASS_APIURL: 'FeeManagement/FeeStructure/Delete',
  ADD_NOTICE_BY_ROLE: "NoticeDashboard/Add/NoticeByRole",
  UPDATE_NOTICE_BY_ROLE: "NoticeDashboard/update/NoticeByRole",
  DELETE_NOTICE_BY_ROLE: "NoticeDashboard/delete/NoticeDetails/NoticeId",
  ROLE_NOTIFICATION_BY_NOTICEID: "NoticeDashboard/RoleNoticeDetailsBy/NoticeId",
  ALL_NOTICE_LIST: "NoticeDashboard/allnoticeList",
  GET_NOTICE_CATEGORY_LIST: "NoticeDashboard/NoticeCategoryList",


  GET_ALL_ROLES: 'AdminDashboard/GetAllRoles',
  GET_ALL_MENU_LIST: 'AdminDashboard/GetAllMenuList',
  GET_INSERT_AND_UPDATE_ROLE_ROUTE: 'AdminDashboard/insertAndUpdate/RoleRoute',
  GET_ROUTE_DETAIL_BY_ROLE_ID: 'AdminDashboard/GetRouteDetailsByRoleId',

  SIDEBAR_CONFIGURATION_GET_ALL_LABEL: 'SchoolDashboard/SidebarMenuLabel/GetAll',
  SIDEBAR_CONFIGURATION_INSERT_OR_UPDATE: 'SchoolDashboard/SidebarMenuLabel/InsertOrUpdate',
  // FEES COLLECTION  APIS

  GETALL_FEECOLLECTION_APIURL: "FeeManagement/FeeStructure/Get",
  UPDATE_ALL_FEE_COLLECTION_APIURL: "FeeManagement/FeeCollection/InsertOrUpdate",
  GET_ALL_FEE_COLLECTION_APIURL: "FeeManagement/FeeCollection/Get",
  GETALL_SUBJECTLIST: "Student/studentSubjectList",
  GET_ADMIN_DASHBOARD_DATA: 'AdminDashboard/GetAdminDashboardData',
  GET_ALL_COLLECTION_STATUS_LIST: "FeeManagement/FeeCollection/get-all",
  INSERT_OR_UPDATE_FEE_REMINDER: 'FeeManagement/FeeReminder/InsertOrUpdate',
  GET_ALL_FEE_TYPES: 'FeeManagement/fee-type/get-all',
  GET_ALL_FEE_REMINDERS: 'FeeManagement/FeeReminder/GetAll',
  GET_ALL_FEE_REMINDERS_EMAILS: 'FeeManagement/FeeReminderEmailTo/GetAll',
  DELETE_FEE_REMINDER: 'FeeManagement/FeeReminder/Delete',
  INSERT_OR_UPDATE_FEE_REMINDER_MESSAGE: 'FeeManagement/FeeReminderMessage/InsertOrUpdate',
  GET_ALL_FEE_REMINDERSMESSAGE: 'FeeManagement/FeeReminderMessage/GetAll',
  DELETE_FEE_REMINDER_MESSAGE: 'FeeManagement/FeeReminderMessage/Delete',
  GET_ALL_FEES_COLLECTION_CHECK_STATUS_LIST: 'Student/student-fee-details',
  GET_ALL_FEES_VIEW_COLLECTION_CHECK_STATUS_LIST: 'Student/student-fee-view-details',
  GET_ALL_STUDENT_FEE_DETAILS_LIST: 'Student/studentFeesViewDetails',

  GET_ALL_CALENDER_DATA: 'SchoolDashboard/SchoolCalender/GetAll',
  THEME_INSERT_AND_UPDATE: 'AdminDashboard/insertAndUpdate/ThemeSetting',
  GETALL_THEME_DETAILS: 'AdminDashboard/GetThemeDetails/SchoolID',
  ADMIN_PROFILE: 'AdminDashboard/GetAdminprofile/AdminId',
  GET_INVOICE_BY_FEE_COLLECT_ID: "FeeManagement/FeeInvoice/Get",
  UPDATE_ADMIN_PROFILE: 'User/adminProfile-update',
  GET_LOGO_BASE64POST: "ClassSection/get-logoInsert-base64",
  SIDEBAR_UPDATEDMENU: 'SchoolDashboard/SidebarMenuLabel/GetAll',
  CREATE_TICKET_SUPPORT: 'AdminDashboard/CreateTicket/Support',
  GET_ALL_TICKETS_SUPPORT: 'AdminDashboard/GetAllTickets/Support',
  GET_STAFF_DETAILS: "EmployeeManage/staff/Get",
  GET_EMPLOYEE_CHANGE_PASSWORD: "User/employee-change-password",
  CREATE_EXAM: "Reports/CreateExam",
  GET_EXAM_LIST: "Reports/GetExamList",
  UPDATE_EXAM: "Reports/UpdateExam",
  DELETE_EXAM_DETAILS: "Reports/delete-ExamDetail/ExamID",
  BULK_UPLOAD_STUDENT_REGISTRATION: 'Student/BulkRegistrationStudent',
  BULK_UPLOAD_EMPLOYEE_REGISTRATION: 'EmployeeManage/BulkRegistrationEmployee',
  // Leave Master Api
  GET_ALL_LEAVE_MASTER_TYPES: 'EmployeeManage/get-leave-types',
  ADD_LEAVE_MASTER_TYPES: 'EmployeeManage/add-leave-type',
  UPDATE_LEAVE_MASTER_TYPES: 'EmployeeManage/Update-leave-type',
  DELETE_LEAVE_MASTER_TYPES: 'EmployeeManage/delete-leave-type',

  // My Leave Api For Employee 
  GET_STAFF_LEAVE_BY_EMPLOYEE: 'EmployeeManage/staff-leaves/by-employee',
  ADD_STAFF_LEAVE: 'EmployeeManage/staff-leaves/add',
  UPDATE_STAFF_LEAVE: 'EmployeeManage/update-employee-leave',
  DELETE_STAFF_LEAVE: 'EmployeeManage/delete-employee-leave',

  // My Leave Api For Student
  GET_STUDENT_LEAVE_DATA: "Student/get-studentbyID-leaves",
  STUDENT_APPLY_LEAVE: "Student/Student-apply-leave",
  UPDATE_LEAVE_BY_STUDENT: 'Student/Student-update-leave',
  DELETE_LEAVE_BY_STUDENT: 'Student/Student-delete-leave',

  // Approve Request Api for Admin
  GET_ALL_EMPLOYEE_LEAVE_DATA: 'EmployeeManage/getAdmin-AllEmployeesLeaves',
  GET_ALL_STUDENT_LEAVE_DATA: 'Student/get-all-student-leaves',
  APPROVE_LEAVE_REQUEST_BY_ADMIN: "AdminDashboard/review-by-admin",
  DELETE_STUDENT_EMPLOYEE_LEAVE: "AdminDashboard/Admin-delete-leave-approval",

  // Approve Request Api for Teacher
  APPROVE_LEAVE_REQUEST_BY_TEACHER: "Student/ReviewByTeacher",
  DELETE_STUDENT_LEAVE: "Student/Student-delete-leave",


  MARK_EMPLOYEE_ATTENDANCE: 'Reports/addEmployeeMarkAttendance',
  GET_ALL_EMPLOYEE_ATTENDANCE_LIST: 'Reports/GetAllEmployeeAttendanceList',
  UPDATE_EMPLOYEE_ATTENDANCE: 'Reports/UpdateEmployeeMarkAttendance',
  STAFF_PUNCHIN_PUNCHOUT: 'Reports/Staff-PunchIn-PunchOut',
  GET_EMPLOYEE_ATTENDANCE_REPORT_LIST: 'Reports/GetEmployeeAttendanceReportList',
  CREATE_EXAM_SCHEDULE: "Reports/CreateExamSchedule",
  GET_EXAM_SCHEDULE_BY_CLASS: "Reports/GetExamScheduleByClass",
  EXAM_STATUS_UPDATE: "Reports/examStatus-Update",
  UPDATE_EXAM_SCHEDULE: "Reports/UpdateExamSchedule",
  DELETE_EXAM_SCHEDULE_DETAIL: "Reports/delete-ExamScheduleDetail",
  CREATE_HOLIDAY: "NoticeDashboard/Add/Holiday",
  UPDATE_HOLIDAY: "NoticeDashboard/Update/Holiday",
  DELETE_HOLIDAY: "NoticeDashboard/Delete/Holiday",
  GETALL_HOLIDAY: "NoticeDashboard/get-all-holidays",
  HOMEWORK_FILTER: 'Homework/GetHomeWorkDataByFilters',
  INSERT_HOMEWORKDATA: 'Homework/InsertHomework',
  HOMEWORK_EVALUATION_REPORT: 'Homework/GetHomeworkEvaluationReport',
  DELETE_HOMEWORK: 'Homework',
  ADD_UPDATE_EXAM_MARKS: 'Reports/AddOrUpdate-ExamMarks',
  GET_EXAM_MARKS_BY_CLASS: 'Reports/GetExamMarksByClass',
  GET_EXAM_RESULT_REPORT: 'Reports/GetExamResultReport',
  SAVE_HOMEWORK_EVALUATION: 'Homework/SaveHomeworkEvaluation',

  GET_STUDENT_HOMEWORKDASHBOARD_DATA: 'Homework/GetStudentHomeworkDashboard',
  CLASS_TEACHER_SUBJECT_MAPPING: 'Reports/GetClassTeacherSubjectMapping',

  // Timetable api for studentDashboard
   GET_TIMETABLE_STUDENTDASHBOARD:"Student/student-TimeTable",

  // Today Class Api For Teacher Dashboard 
   GET_TODAY_CLASSES_FOR_TEACHER:'EmployeeManage/Teacher/TodayClasses',
     SAVE_AND_UPDATE_TRANSFERHISTORY:"Student/StudentTransferHistory-SaveOrUpdate",

     // birthday reminder for Teacher Dashboard
       GET_BIRTHDAY_REMINDER_FOR_TEACHER:'EmployeeManage/Teacher/BirthdayReminders',
       STUDENT_CHANGE_PASSWORD:'User/student-change-password',
       GET_TRANSFER_HISTORY:'Student/get-transfer-history',
       GET_DEACTIVE_STUDENTS_BYID:'Student/GetDeactiveStudentDetailsById',
  
  // Route Management 
  GET_ALL_BUS_ROUTE_LIST : 'TransportManage/GetAll-BusRouteList',
  INSERT_BUS_ROUTE : 'TransportManage/insert/BusRoute',  
  UPDATE_BUS_ROUTE: 'TransportManage/update/BusRoute',
  DELETE_BUS_ROUTE: 'TransportManage/delete-BusRoute', 
  UPDATE_ROUTE_STATUS: 'TransportManage/RouteStatus-Update',
       
  // TransportManage Bus Management
  // GET_ALL_BUS_ROUTE_LIST:'TransportManage/GetAll-BusRouteList',
  GET_ALL_DRIVER_LIST:'TransportManage/GetAll-DriverList',
  GET_ALL_HELPER_LIST:'TransportManage/GetAll-HelperList',
  INSERT_VEHICLE_DETAILS:'TransportManage/insert/VehicleDetails',
  UPDATE_VEHICLE_DETAILS:'TransportManage/update/VehicleDetails',
  GET_ALL_VECHICLE_LIST:'TransportManage/GetAll-VehicleList',
  DELETE_VECHICLE_LIST:'TransportManage/delete-VehicleDetails',
  STATUS_TOGGLE_VECHICLE:'TransportManage/Status/VehicleDetails',



//GatePass Master  Api

EXIT_GATE_MASTER_POST:"GateMaster/exit-gate",
EXIT_GATE_MASTER_GET:"GateMaster/exit-gate",
EXIT_GATE_MASTER_PUT:"GateMaster/exit-gate/",
EXIT_GATE_MASTER_DELETE:"GateMaster/exit-gate/",

//Visit Type GatePass
ADD_VISIT_PURPOSE:"GateMaster/visitor-type",
GET_VISIT_PURPOSE:"GateMaster/visitor-type",
DELETE_VISIT_PURPOSE:"GateMaster/visitor-type/",
UPDATE_VISIT_PURPOSE:"GateMaster/visitor-type/",

//AdminControl Pannel API
CREATE_SCHOOL:'AdminDashboard/Create/School',
GET_ALL_SCHOOLS:'AdminDashboard/GetAllSchools',
GET_ALL_Admins:'AdminDashboard/GetAllAdmins',
CREATE_ADMIN_FOR_SCHOOL:'User/admin-register',
TICKETS_TRACKING_ACTIONS:'AdminDashboard/Ticket-Tracking-actions',
GET_SCHOOL_LIST:'SchoolDashboard/GetSchool-List',

//Group List Api
GET_ALL_GROUPS:"SchoolDashboard/GetSchoolGroup-List",
POST_GROUP_LIST:"SchoolDashboard/Save/Update-SchoolGroup",
GETALL_SCHOOLlIST:"SchoolDashboard/AllSchoolGroupList",

//For more Admins
SET_ADMINS_SCHOOLACCESS:"AdminDashboard/SetAdminSchoolAccess",
GET_ADMINS_SCHOOL:"AdminDashboard/GetAdminSchools/",

// school OnBoarding api
GET_ALL_SCHOOLS_ONBOARDING_DATA: "AdminDashboard/Get/SchoolOnboarding",

};


